<template>
  <sui-form-field :width="field.width || 16" v-if="!field.hidden">
    <label>
      Access from
    </label>
    <div class="ui vertical fluid buttons">
      <div class="ui button" :class="{active: !$attrs.value, disabled: field.readonly}" @click.prevent="set(false)">Only private network</div>
      <div class="ui button" :class="{active: $attrs.value, disabled: field.readonly}" @click.prevent="set(true)">Internet and private network</div>
    </div>
    <!-- <div class="icons">
      <i class="window maximize big icon" />
      <i class="exchange big icon" />
      <i class="window maximize big icon" />
      <i class="big icon" :class="$attrs.value ? 'exchange' : 'long arrow alternate right disabled'" />
      <i class="globe big icon" :class="{disabled: !$attrs.value}" />
    </div> -->
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormServiceRemoteAccess',
    mixins: [
      FormField,
    ],
  }
</script>

<style scoped>
  .icons { margin: .7em 1em 0; padding: .6em; display: flex; justify-content: space-around; }
  .disabled { opacity: .2!important; }
</style>
